(function() {
  'use strict';

  var SHOP_TARGET_IDS = [
    'ps_kits_regular',
    'ps_kits_tricoat',
    'ps_products_regular',
    'ps_products_tricoat'
  ];
  var changeVehicleScriptStatus = {};

  function hasClass(el, className) {
    return el && (' ' + el.className + ' ').indexOf(' ' + className + ' ') >= 0;
  }

  function addClass(el, className) {
    if (!el || hasClass(el, className)) return;
    el.className = String(el.className || '') + ' ' + className;
  }

  function removeClass(el, className) {
    var current;
    if (!el || !hasClass(el, className)) return;
    current = ' ' + String(el.className || '') + ' ';
    el.className = current.replace(' ' + className + ' ', ' ').replace(/^\s+|\s+$/g, '');
  }

  function trim(value) {
    return String(value || '').replace(/^\s+|\s+$/g, '');
  }

  function lower(value) {
    return trim(value).toLowerCase();
  }

  function slugify(value) {
    return lower(value)
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function titleCaseFromSlug(value) {
    var parts = trim(value).split(/[-_]+/);
    var out = [];
    var i;
    var part;
    for (i = 0; i < parts.length; i++) {
      part = trim(parts[i]);
      if (!part) continue;
      out.push(part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
    }
    return out.join(' ');
  }

  function cleanTokenValue(value) {
    var out = trim(value);
    if (!out) return '';
    if (out.charAt(0) === '[' && out.charAt(out.length - 1) === ']') return '';
    return out;
  }

  function readAttr(el, name) {
    if (!el || !el.getAttribute) return '';
    return cleanTokenValue(el.getAttribute(name));
  }

  function readButtonContext(button) {
    var make = readAttr(button, 'data-ps-color-hub-make');
    var makeSlug = lower(readAttr(button, 'data-ps-color-hub-make-slug'));
    if (!makeSlug && make) makeSlug = slugify(make);
    return {
      make: make,
      make_slug: makeSlug
    };
  }

  function parseColorHubPath() {
    var path = '';
    var parts;
    try {
      path = window.location && window.location.pathname ? String(window.location.pathname) : '';
    } catch (_e) {
      path = '';
    }
    parts = path.replace(/^\/+|\/+$/g, '').split('/');
    if (parts.length < 3 || lower(parts[0]) !== 'colors') {
      return { make_slug: '', color_slug: '' };
    }
    return {
      make_slug: lower(parts[1]),
      color_slug: lower(parts[2])
    };
  }

  function readSsr() {
    try {
      if (window.PS && typeof window.PS.ssr === 'function') {
        return window.PS.ssr() || {};
      }
    } catch (_e) {}
    try {
      return window.PS_SSR && typeof window.PS_SSR === 'object' ? window.PS_SSR : {};
    } catch (_e2) {}
    return {};
  }

  function readPsCc() {
    var match;
    try {
      if (window.PS && window.PS.cc && typeof window.PS.cc.read === 'function') {
        return window.PS.cc.read() || {};
      }
    } catch (_e) {}
    try {
      match = String(document.cookie || '').match(/(?:^|; )ps_cc=([^;]*)/);
      if (!match) return {};
      return JSON.parse(decodeURIComponent(match[1] || '')) || {};
    } catch (_e2) {}
    return {};
  }

  function readChangeVehicleContext(button) {
    var buttonContext = readButtonContext(button);
    var ssr = readSsr();
    var pathParts = parseColorHubPath();
    var cc = readPsCc();
    var makeSlug = lower(buttonContext.make_slug || ssr.make_slug || pathParts.make_slug || slugify(buttonContext.make || ssr.make));
    var make = trim(buttonContext.make || ssr.make || titleCaseFromSlug(makeSlug));
    var pageMakeSlug = slugify(makeSlug || make);
    var ccMakeSlug = slugify(cc.make_slug || cc.make);
    var context = {
      make: make,
      make_slug: makeSlug
    };
    if (ccMakeSlug && pageMakeSlug && ccMakeSlug === pageMakeSlug) {
      context.year = trim(cc.year);
      context.model = trim(cc.model);
    }
    return context;
  }

  function isVisible(el) {
    var style;
    if (!el) return false;
    style = window.getComputedStyle ? window.getComputedStyle(el) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden')) return false;
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function findHeading(el) {
    var heading;
    if (!el || !el.querySelector) return null;
    heading = el.querySelector('h2, h3, .title, .collection__title, .rich-text__heading');
    return heading || el;
  }

  function focusTarget(el) {
    var target = findHeading(el);
    if (!target || !target.focus) return;
    if (!target.getAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    try {
      target.focus({ preventScroll: true });
    } catch (_e) {
      try { target.focus(); } catch (_ignore) {}
    }
  }

  function firstVisibleShopTarget() {
    var targetId = firstVisibleShopTargetId();
    if (!targetId) return null;
    return document.getElementById(targetId);
  }

  function firstVisibleShopTargetId() {
    var i;
    var el;
    for (i = 0; i < SHOP_TARGET_IDS.length; i++) {
      el = document.getElementById(SHOP_TARGET_IDS[i]);
      if (isVisible(el)) return SHOP_TARGET_IDS[i];
    }
    return '';
  }

  function syncShopHref(button) {
    var targetId = firstVisibleShopTargetId();
    if (targetId && button && button.setAttribute) {
      button.setAttribute('href', '#' + targetId);
    }
  }

  function scrollToShopTarget() {
    var target = firstVisibleShopTarget();
    if (!target) return false;
    if (target.scrollIntoView) {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (_e) {
        target.scrollIntoView(true);
      }
    }
    window.setTimeout(function() {
      focusTarget(target);
    }, 450);
    return true;
  }

  function bindShopButtons(root) {
    var buttons;
    var i;
    buttons = root.querySelectorAll('[data-ps-color-hub-shop]');
    for (i = 0; i < buttons.length; i++) {
      syncShopHref(buttons[i]);
      buttons[i].addEventListener('click', function(evt) {
        syncShopHref(this);
        if (scrollToShopTarget()) {
          evt.preventDefault();
        }
      });
    }
  }

  function setVerifyOpen(root, button, drawer, open) {
    drawer.hidden = !open;
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      addClass(root, 'ps-color-hub-banner--verify-open');
    } else {
      removeClass(root, 'ps-color-hub-banner--verify-open');
    }
  }

  function bindVerifyDrawer(root) {
    var button = root.querySelector('[data-ps-color-hub-verify-toggle]');
    var drawer = root.querySelector('[data-ps-color-hub-verify-drawer]');
    if (!button || !drawer) return;
    setVerifyOpen(root, button, drawer, false);
    button.addEventListener('click', function() {
      setVerifyOpen(root, button, drawer, drawer.hidden);
    });
    document.addEventListener('keydown', function(evt) {
      if (evt.key === 'Escape' || evt.keyCode === 27) {
        if (!drawer.hidden) {
          setVerifyOpen(root, button, drawer, false);
        }
      }
    });
  }

  function getChangeVehicleApi() {
    try {
      if (window.PS && window.PS.VehicleDetails && typeof window.PS.VehicleDetails.openChangeVehicleModal === 'function') {
        return window.PS.VehicleDetails.openChangeVehicleModal;
      }
    } catch (_e) {}
    return null;
  }

  function findScriptSrc(needle) {
    var scripts = document.getElementsByTagName('script');
    var i;
    var src;
    for (i = 0; i < scripts.length; i++) {
      src = String(scripts[i].getAttribute('src') || '');
      if (src.indexOf(needle) >= 0) return src;
    }
    return '';
  }

  function finishScriptLoad(key, ok) {
    var status = changeVehicleScriptStatus[key];
    var callbacks;
    var i;
    if (!status) return;
    callbacks = status.callbacks || [];
    status.loading = false;
    status.loaded = !!ok;
    status.callbacks = [];
    for (i = 0; i < callbacks.length; i++) {
      try { callbacks[i](!!ok); } catch (_e) {}
    }
  }

  function loadScriptOnce(src, key, done) {
    var cb = typeof done === 'function' ? done : function() {};
    var status;
    var script;
    var parent;
    if (!src) {
      cb(false);
      return;
    }
    key = key || src;
    status = changeVehicleScriptStatus[key];
    if (status && status.loaded) {
      cb(true);
      return;
    }
    if (status && status.loading) {
      status.callbacks.push(cb);
      return;
    }
    changeVehicleScriptStatus[key] = {
      loading: true,
      loaded: false,
      callbacks: [cb]
    };
    script = document.createElement('script');
    script.src = src;
    script.onload = function() { finishScriptLoad(key, true); };
    script.onerror = function() { finishScriptLoad(key, false); };
    parent = document.head || document.body || document.documentElement;
    parent.appendChild(script);
  }

  function ensureChangeVehicleApi(done) {
    var cb = typeof done === 'function' ? done : function() {};
    var api = getChangeVehicleApi();
    var modalSrc;
    var pdpSrc;
    if (typeof api === 'function') {
      cb(api);
      return;
    }
    modalSrc = findScriptSrc('ps-modal.js');
    pdpSrc = findScriptSrc('ps-pdp.js');
    loadScriptOnce(modalSrc, 'ps-modal.js', function() {
      loadScriptOnce(pdpSrc, 'ps-pdp.js', function() {
        cb(getChangeVehicleApi());
      });
    });
  }

  function setChangeVehicleBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('data-ps-color-hub-change-vehicle-busy', 'true');
      return;
    }
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.removeAttribute('data-ps-color-hub-change-vehicle-busy');
  }

  function bindChangeVehicle(root) {
    var button = root.querySelector('[data-ps-color-hub-change-vehicle]');
    if (!button || button.getAttribute('data-ps-color-hub-change-vehicle-bound') === 'true') return;
    button.setAttribute('data-ps-color-hub-change-vehicle-bound', 'true');
    button.addEventListener('click', function(evt) {
      var api = getChangeVehicleApi();
      var context;
      if (evt && evt.preventDefault) evt.preventDefault();
      if (button.getAttribute('data-ps-color-hub-change-vehicle-busy') === 'true') return;
      context = readChangeVehicleContext(button);
      if (typeof api === 'function') {
        api(context);
        return;
      }
      setChangeVehicleBusy(button, true);
      ensureChangeVehicleApi(function(resolvedApi) {
        setChangeVehicleBusy(button, false);
        if (typeof resolvedApi === 'function') {
          resolvedApi(context);
        }
      });
    });
  }

  function bindMobileSearch() {
    var searchRoot;
    var button;
    var input;
    if (!hasClass(document.body, 'ps-color-hub-page')) return;
    searchRoot = document.querySelector('.header__icons .header__search--mobile, .header__search--mobile');
    if (!searchRoot || searchRoot.getAttribute('data-ps-color-hub-search-bound') === 'true') return;
    button = searchRoot.querySelector('.search__button');
    input = searchRoot.querySelector('input[type="search"]');
    if (!button || !input) return;
    searchRoot.setAttribute('data-ps-color-hub-search-bound', 'true');
    function closeSearch(focusButton) {
      removeClass(searchRoot, 'ps-header-search-open');
      if (focusButton && button.focus) {
        try { button.focus(); } catch (_e) {}
      }
    }
    button.addEventListener('click', function(evt) {
      if (!hasClass(searchRoot, 'ps-header-search-open')) {
        evt.preventDefault();
        addClass(searchRoot, 'ps-header-search-open');
        try { input.focus(); } catch (_e) {}
      }
    });
    document.addEventListener('keydown', function(evt) {
      if (evt.key === 'Escape' || evt.keyCode === 27) {
        if (hasClass(searchRoot, 'ps-header-search-open')) {
          evt.preventDefault();
          closeSearch(true);
        }
      }
    });
    document.addEventListener('click', function(evt) {
      if (!hasClass(searchRoot, 'ps-header-search-open')) return;
      if (searchRoot.contains && searchRoot.contains(evt.target)) return;
      if (trim(input.value) !== '') return;
      closeSearch(false);
    });
  }

  function init() {
    var roots;
    var i;
    roots = document.querySelectorAll('.ps-color-hub-banner');
    for (i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-ps-color-hub-hero-bound') === 'true') continue;
      roots[i].setAttribute('data-ps-color-hub-hero-bound', 'true');
      bindShopButtons(roots[i]);
      bindVerifyDrawer(roots[i]);
      bindChangeVehicle(roots[i]);
    }
    bindMobileSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
